import { render } from "./DebugPanel.vue?vue&type=template&id=4f62cc30&scoped=true"
import script from "./DebugPanel.vue?vue&type=script&lang=js"
export * from "./DebugPanel.vue?vue&type=script&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=4f62cc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f62cc30"]])

export default __exports__